import React from "react";

const twoColumn = ({ block }) => (
  <section className="section-listing--gray">
    <div className="shell">
      <div className="flex flex-col lg:flex-row sapce-x-0 lg:space-x-8 pb-8 mb-8">
        <div className="flex-1 prose max-w-none">
          <div dangerouslySetInnerHTML={{ __html: block.twoColumnRichText, }}/>
        </div>
        <div className="flex-1 prose max-w-none">
          <div dangerouslySetInnerHTML={{ __html: block.twoColumnRichText2, }}/>
        </div>
      </div>
    </div>
  </section>  
);

export default twoColumn;
